import React from 'react';
import { useUser } from '@lore/auth';
import { Helmet } from 'react-helmet-async';
import ParentLayout from '../Layout';
import Urls from '../Urls';
import Form from './Form';
import useRouter from '../../../hooks/useRouter';
import useRoles from '../../../hooks/useRoles';
import useSetupNavigation from '../useSetupNavigation';

export default function Layout(props) {
  const { history } = useRouter();
  const user = useUser();

  const navigation = useSetupNavigation(Urls.PAST_ENGAGEMENT);

  const { isClassroomTeacher } = useRoles();

  return (
    <ParentLayout>
      <Helmet>
        <title>Setup - Past Engagement</title>
      </Helmet>
      <Form
        user={user}
        navigation={navigation}
        onPrevious={(newData) => isClassroomTeacher ? history.push(Urls.PRACTICES) : history.push(Urls.SCHOOL)}
        onNext={() => history.push(Urls.PARTNER_INTENT)}
        onSkip={() => history.push(Urls.SKILLS_INTRODUCTION)}
      />
    </ParentLayout>
  );
};
